/**
 * Copyright (c) 2010-2026 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MsGroupNode, MsLayerNode, TraverseGroupCallback, TraverseLayerCallback } from '../state/map-config.model';

export function traverseLayers(
    context: Array<MsGroupNode | MsLayerNode>,
    targetLayer: string | string[] | null,
    layerCallback: TraverseLayerCallback,
    groupCallback: TraverseGroupCallback
): MsLayerNode[] {
    let result = [];
    const obj = context[context.length - 1];
    Object.getOwnPropertyNames(obj).forEach((key) => {
        if (key === 'layers') {
            const layers = obj[key];
            if (typeof targetLayer === 'string' && targetLayer.length > 0) {
                const foundLayer = layers.find((el) => el.name === targetLayer);
                if (foundLayer) {
                    const answer = layerCallback.call(null, targetLayer, foundLayer, context);
                    if (answer) {
                        result.push(answer);
                    }
                }
            } else if (Array.isArray(targetLayer)) {
                for (const testTargetLayer of targetLayer) {
                    const foundLayer = layers.find((el) => el.name === testTargetLayer);
                    if (foundLayer) {
                        const answer = layerCallback.call(null, testTargetLayer, foundLayer, context);
                        if (answer) {
                            result.push(answer);
                        }
                    }
                }
            } else {
                layers.forEach((layer) => {
                    const layerName = layer.name;
                    const answer = layerCallback.call(null, layerName, layer, context);
                    if (answer) {
                        result.push(answer);
                    }
                });
            }
        } else if (key === 'groups') {
            const groups = obj[key];
            groups.forEach((group) => {
                const groupName = group.name;
                if (groupCallback.call(null, groupName, group)) {
                    const tmp = traverseLayers(
                        context.concat(group),
                        targetLayer,
                        layerCallback,
                        groupCallback
                    );
                    result = result.concat(tmp);
                }
            });
        }
    });
    return result;
}

export function traverseGroups(obj, targetGroup, groupCallback) {
    const result = [];
    Object.getOwnPropertyNames(obj).forEach((key) => {
        if (key === 'groups') {
            const groups: MsGroupNode[] = obj[key];
            if (typeof targetGroup === 'string' && targetGroup.length > 0) {
                const foundGroup = groups.find((el) => el.name === targetGroup);
                if (foundGroup) {
                    const answer = groupCallback.call(null, targetGroup, foundGroup);
                    if (answer) {
                        result.push(answer);
                    }
                } else {
                    groups.forEach((group) => {
                        const answer = traverseGroups(group, targetGroup, groupCallback);
                        if (answer) {
                            result.push(answer);
                        }
                    });
                }
            }
        }
    });
    return result;
}
